import { AiAgentWithFacts } from '../../../aiAgentCenter/aiAgentsConsts';
import { AgentFactKey } from '@server/ai';

export const getTotalIssues = (monitoringAgents: AiAgentWithFacts[]) => {
  return monitoringAgents.reduce((total, agent) => {
    const totalIssuesFact =
      agent.facts?.find((fact) => fact.key === AgentFactKey.TOTAL_ISSUES)?.value ?? 0;
    const issues = agent.issues?.length ?? 0;

    return total + (totalIssuesFact || issues);
  }, 0);
};
